import React from 'react';
import {Route, RouteProps, useLocation, useRouteMatch} from 'react-router';
import {Location} from 'history';
import Keycloak from 'keycloak-js';
import {useKeycloak} from "@react-keycloak/web";

export interface ReservedRouteProps  extends RouteProps {
    path: string;
    token?: Keycloak.KeycloakInstance;
    checkParams?: (params: any) => boolean;
    // action: ( location: Location  ) => void;
    onAuthenticated?: (token: Keycloak.KeycloakInstance, location: Location) => void;
    onError?: (error: any, location: Location) => void;
    onUpdated?: (token: Keycloak.KeycloakInstance, location: Location) => void;
    noMatch?: React.ReactNode;
    error: React.ReactElement<any>;
    redirect?: (token: Keycloak.KeycloakInstance) => string;
}

const mainURL = window.location.origin;

const ReservedRoute:React.FC<ReservedRouteProps> = (props:ReservedRouteProps) => {
    const location = useLocation();

    const match = useRouteMatch(props.path);

    const { keycloak, initialized } = useKeycloak();

    const token = keycloak;

    const initOrRefreshToken = (token: Keycloak.KeycloakInstance,location: Location): void => {
/*
        const { onAuthenticated, onError,  redirect, onUpdated } = props;


        console.log('initOrRefreshToken: ', token);



        if (token !== undefined && token.authenticated) {
            return;
        }
*/

        if (token !== undefined && initialized) {

            if (!token.authenticated) {
                token.login({redirectUri: mainURL + location.pathname + location.search});
            }
        }

/*
            token.init({onLoad: 'check-sso', checkLoginIframe: false})
                .then((authenticated: boolean) => {
                    if (authenticated) {
                        // Chiamo callback nel caso in cui sia autenticato.
                        if (onAuthenticated) {
                            onAuthenticated(token, location);
                        }
                        // Update Token
                        setInterval(
                            () => {
                                token.updateToken(5)
                                    .then((refreshed: boolean) => {
                                        if (refreshed) {
                                            // Dovrebbe essere utilizzato questo handler
                                            if (onUpdated) {
                                                onUpdated(token, location);
                                            } else {
                                                // alternativamente si potrebbe riutilizzare questo
                                                // handler se presente
                                                if (onAuthenticated) {
                                                    onAuthenticated(token, location);
                                                }
                                            }
                                            console.debug('refreshed');
                                        }

                                    })
                                    .catch(
                                        () => {
                                            if (token) {
                                                token.logout({redirectUri: `${mainURL}${ROOT_REDIRECT}`});
                                            }
                                        })
                            },
                            10000);
                    } else {
                        let redirectUrl: string;
                        if (redirect) {
                            redirectUrl = mainURL + redirect(token);
                        } else {
                            redirectUrl = mainURL + location.pathname + location.search;
                        }
                        //  console.log("RedirectURL: ", redirectUrl);
                        token.login({redirectUri: redirectUrl});
                    }
                })
                .catch((error: any) => {
                    // Se presente chiamo callback onerror
                    console.error('Error: ', error);
                    if (onError) {
                        onError(error, location);
                    }
                });
        }
        */
    };



    React.useEffect(()=> {
        if (token !== undefined) {
            initOrRefreshToken(token, location);
        }
    }, [token, initOrRefreshToken]);

/*
    // console.log("Props: ", this.props);
    let {children} = props;

    //        console.log("RENDER RESERVED ROUTE ", token.authenticated);
    let wrappedComps: Array<React.ReactElement<any>> = [];

    if (props.checkParams !== undefined && !props.checkParams(match)) {
        wrappedComps.push(props.error);
    } else {
        //console.log('AuthToken: ', auth, auth.token !== undefined && auth.token.authenticated, auth.realm);
        if (token !== undefined && token.authenticated) {
            React.Children.forEach(children as React.ReactElement<any>, (child: React.ReactElement<any>, index) => {
                wrappedComps.push(
                    React.cloneElement(child, {key: index, token: token, location: props.location}
                    )
                );
            });
        }
    }

*/

    const childrenWrapper = (children: React.ReactNode):React.ReactNode  => {
        if (props.checkParams !== undefined && !props.checkParams(match)) {
            return props.error;
        } else {
            if (children !== undefined) {
                if (Array.isArray(children)) {
                    return children.map((child, i) => {
                        if (React.isValidElement(child)) {
                            return React.cloneElement(child, props)
                        }
                    })
                } else {
                    if (React.isValidElement(children)) {
                        return React.cloneElement(children, props)
                    }
                }
            }
        }
        return children;
    };

    const authWrapper = (children: React.ReactNode): React.ReactNode => {
        if (initialized && keycloak.authenticated) {
            return childrenWrapper(children);
        }
    };

    return (
        <Route {...props as RouteProps}>
            {
                authWrapper(props.children)
            }

        </Route>
    )
};

export default ReservedRoute;